import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import { Sidebar, Segment, Menu } from 'semantic-ui-react';
import { SIDEBAR_ANIMATION_DURATION } from './SidebarWithFixedPusher.constants';
import { ChildrenPropType, DirectionPropType } from '../../services/proptypes';
import './SidebarWithFixedPusher.css';
var defaultProps = {
  direction: 'bottom',
  className: '',
  show: undefined,
  defaultShow: false,
  onShow: null
};
function SidebarWithFixedPusher(_ref) {
  var children = _ref.children,
    pusherContent = _ref.pusherContent,
    direction = _ref.direction,
    className = _ref.className,
    onShow = _ref.onShow,
    defaultShow = _ref.defaultShow,
    show = _ref.show;
  // Currently this component only supports placing the fixed Pusher at the bottom

  var _useRef = useRef(show !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(defaultShow),
    _useState2 = _slicedToArray(_useState, 2),
    showSidebar = _useState2[0],
    setShowSidebar = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showPusher = _useState4[0],
    setShowPusher = _useState4[1];
  var showSidebarDerived = isControlled ? show : showSidebar;
  function showBodyScroll() {
    document.body.style.overflow = '';
  }
  function hideBodyScroll() {
    document.body.style.overflow = 'hidden';
  }
  useEffect(function () {
    if (defaultShow) {
      hideBodyScroll();
    }
    return function () {
      showBodyScroll();
    };
  }, []);
  function displaySidebar() {
    if (!isControlled) {
      hideBodyScroll();
      setShowSidebar(true);
    }
    if (onShow) {
      onShow(true);
    }
  }
  function hideSidebar() {
    if (!isControlled) {
      showBodyScroll();
      setShowSidebar(false);
    }
    if (onShow) {
      onShow(false);
    }
  }
  function getClassName() {
    var classNames = ['sidebar-with-fixed-pusher-container'];
    if (showPusher) {
      classNames.push('visible-pusher');
    }
    if (className) {
      classNames.push(className);
    }
    return classNames.join(' ');
  }
  useEffect(function () {
    if (showSidebarDerived) {
      setShowPusher(false);
      return function () {
        return null;
      };
    }
    // this solution is far from elegant and can probably achieved with pure CSS
    // TODO improve implementation
    var timeout = setTimeout(function () {
      setShowPusher(true);
    }, SIDEBAR_ANIMATION_DURATION);
    return function () {
      clearTimeout(timeout);
    };
  }, [showSidebarDerived]);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(Sidebar.Pushable, {
    as: Segment
  }, /*#__PURE__*/React.createElement(Sidebar, {
    as: Menu,
    vertical: true,
    visible: showSidebarDerived,
    animation: "overlay",
    direction: direction
  }, typeof children === 'function' ? children({
    hideSidebar: hideSidebar,
    showSidebar: displaySidebar
  }) : children), showPusher && /*#__PURE__*/React.createElement(Sidebar.Pusher, null, /*#__PURE__*/React.createElement("div", {
    onClick: displaySidebar,
    onKeyDown: displaySidebar,
    role: "button",
    tabIndex: -1
  }, pusherContent))));
}
SidebarWithFixedPusher.defaultProps = defaultProps;
export default SidebarWithFixedPusher;